export { default } from './DialogContent';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/DialogContent/index.js
// module id = 229
// module chunks = 121